import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import Question from 'on_web/components/shared/Question/Question';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';
import {
  getComorbiditiesValuesArr,
  getComorbiditiesQuestions,
} from 'on_web/helpers/questions';

import { useTranslation } from 'react-i18next';

export default function DiseasesStep5(props) {
  const context = React.useContext(UserProfileContext);

  const noneSaved = () => {
    return (
      context &&
      context.userMetaData &&
      context.userMetaData.covidComorbiditiesAreNone === true
    );
  };

  const getComorbiditiesValues = covidComorbiditiesObj => {
    if (noneSaved()) {
      return ['17'];
    }

    return getComorbiditiesValuesArr(covidComorbiditiesObj);
  };

  const [selectedItems, setSelectedItems] = useState(
    getComorbiditiesValues(context.covidComorbidities)
  );

  const noneSelected = () => {
    return selectedItems.includes('17') && selectedItems.length === 1;
  };

  const setComorbiditiesValues = covidComorbidities => {
    covidComorbidities['hypertension'] =
      selectedItems.includes('1') && !noneSelected() ? 1 : 0;
    covidComorbidities['diabetes'] =
      selectedItems.includes('2') && !noneSelected() ? 1 : 0;
    covidComorbidities['coronary_artery_disease'] =
      selectedItems.includes('3') && !noneSelected() ? 1 : 0;
    covidComorbidities['heart_failure'] =
      selectedItems.includes('4') && !noneSelected() ? 1 : 0;
    covidComorbidities['asthma'] =
      selectedItems.includes('5') && !noneSelected() ? 1 : 0;
    covidComorbidities['obstructive_pulmonary_disease'] =
      selectedItems.includes('6') && !noneSelected() ? 1 : 0;
    covidComorbidities['sleep_apnea'] =
      selectedItems.includes('7') && !noneSelected() ? 1 : 0;
    covidComorbidities['transplant'] =
      selectedItems.includes('8') && !noneSelected() ? 1 : 0;
    covidComorbidities['kidney_disease'] =
      selectedItems.includes('9') && !noneSelected() ? 1 : 0;
    covidComorbidities['liver_disease'] =
      selectedItems.includes('10') && !noneSelected() ? 1 : 0;
    covidComorbidities['autoimmune_disorder'] =
      selectedItems.includes('11') && !noneSelected() ? 1 : 0;
    covidComorbidities['pneumonia'] =
      selectedItems.includes('12') && !noneSelected() ? 1 : 0;
    covidComorbidities['cancer'] =
      selectedItems.includes('13') && !noneSelected() ? 1 : 0;
    covidComorbidities['hiv'] =
      selectedItems.includes('14') && !noneSelected() ? 1 : 0;
    covidComorbidities['hepatitis_b'] =
      selectedItems.includes('15') && !noneSelected() ? 1 : 0;
    covidComorbidities['hepatitis_c'] =
      selectedItems.includes('16') && !noneSelected() ? 1 : 0;
    covidComorbidities['hyperlipidemia'] =
      selectedItems.includes('18') && !noneSelected() ? 1 : 0;
    return covidComorbidities;
  };

  const { t } = useTranslation();
  const questions1 = getComorbiditiesQuestions(selectedItems, t).sort(function(
    a,
    b
  ) {
    // last option (value == 17 == 'I haven't been diagnosed with any') should always be last
    var x = a.value === '17' ? 1 : a.label < b.label ? -1 : 1;
    return x;
  });

  const onCheckboxChange = (val, checked) => {
    if (checked) {
      if (val === '17') {
        setSelectedItems([val]);
      } else {
        setSelectedItems([...selectedItems.filter(i => i !== '17'), val]);
      }
    } else {
      setSelectedItems(selectedItems.filter(i => i !== val));
    }
  };

  const onClickNext = () => {
    const userMetaData = context ? context.userMetaData : null;
    const covidComorbidities = context ? context.covidComorbidities : null;

    if (props.onClickNext && userMetaData && covidComorbidities) {
      if (noneSelected()) {
        userMetaData.covidComorbiditiesAreNone = true;
      } else {
        userMetaData.covidComorbiditiesAreNone = false;
      }

      setComorbiditiesValues(covidComorbidities);
      props.onClickNext(userMetaData, covidComorbidities);
    }
  };

  return (
    <React.Fragment>
      <Header />
      {(context == null || context.editMode !== true) && (
        <StepProgressIndicator
          showBasicQuestions={context.showBasicQuestions}
          selectedSlideIx={
            process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 3 : 2
          }
        />
      )}
      <Question
        sectionTitle={t(
          'onboarding.diseasesSection.diseasesStep4.sectionTitle1'
        )}
        checkboxSelection={{ items: questions1, twoColumns: false }}
        deselectAllValue="17"
        onAnswer={(val, checked) => onCheckboxChange(val, checked)}
      />
      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={selectedItems.length === 0}
        editMode={context && context.editMode && !selectedItems.includes('1')}
      />
    </React.Fragment>
  );
}
